<div class="__profile-actions" *ngIf="profile">
  <!--<button
    mat-stroked-button
    class="__profile-actions-item mip-color&#45;&#45;bg-transparent mip-color&#45;&#45;bd-gray"
    *ngIf="(profile.isFollowing || profile.hasJustFollowed) && !profile.hasJustUnfollowed"
  >
    <span mipTranslate="profile.header.message">Message</span>
  </button>-->

  <mip-profile-following-button class="__profile-actions-item" [profile]="profile" buttonSize="sm"></mip-profile-following-button>

  <button
    mat-stroked-button
    class="__profile-actions-item mip-color--bg-transparent mip-color--bd-gray mip-button--size-sm"
    *ngIf="userNetworks.length > 1"
    [mipBottomSheet]="userNetworks"
  >
    <mip-icon [icon]="userNetworks[0].icon"></mip-icon>
  </button>

  <a
    mat-stroked-button
    class="__profile-actions-item mip-color--bg-transparent mip-color--bd-gray mip-button--size-sm"
    *ngIf="userNetworks.length === 1"
    [href]="userNetworks[0].href"
    target="_blank"
  >
    <mip-icon [icon]="userNetworks[0].icon"></mip-icon>
  </a>

  <!--<button
    mat-stroked-button
    class="__profile-actions-item mip-color&#45;&#45;bg-transparent mip-color&#45;&#45;bd-gray mip-button&#45;&#45;size-sm"
    (click)="shareProfile()"
  >
    <mip-icon icon="share"></mip-icon>
  </button>-->
</div>
